import React, { useEffect, useState } from "react";
import { Backdrop, CircularProgress, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { dobpcard, clock, mobileicon, insurance, dobb, syncbutton, syncbuttonsmall } from "./svgs";
import PatientTabs from "./patienttabs";
import api from "../../api/api";
import dayjs from "dayjs";
import OrderHistoryModal from "./orderhistorymodal";
import UpdateContactModal from "./updatecontact";
import { useSelector } from "react-redux";
import ToastMessage from "../../utils/mui/righttoptoast";
import { ChatIcon, GoogleIcon } from "../patientcharts/frames/svg";
import ConfirmReviewModal from "../patientcharts/frames/googleModal";
import ChatWrapper from "../../header/chat/chatwrapper";

export default function PcardPopup({ setPcard,refereshpcard,data, dob, isPcard }) {
  const practiseid = window.getPracticeId();

  const formattedDate = new Date(dob || data.dob || "").toLocaleDateString(
    "en-US",
    { month: "long", day: "numeric", year: "numeric" }
  );

  const [appointmenthistory, setAppointmentHistory] = useState([]);
  const [chat,setChat]=useState(false)
  const [paymentshistory, setpaymentsHistory] = useState([]);
  const [visitsdata, setvisitsdata] = useState([]);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [issyncing,setIssyncing]=useState(false)
  const [toastSeverity, setToastSeverity] = useState("success");
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("appointments");
  const userConfig = useSelector((state) => state.userconfig);
  const [phonenumber, setPhonenumber] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [reviewtriggered, setReviewTriggered] = useState(false);
  // NEW: collapse/expand state for left rail
  const [collapsed, setCollapsed] = useState(false);

  const [openContactModal, setOpenContactModal] = useState(false);

const [selectedRiskAdjustment, setSelectedRiskAdjustment] = useState("");

const handleRiskAdjustmentChange = async (e) => {
  const value = e.target.value;

    try {
      setIsLoading(true);
      const response = await api.put(
        `/v1/${practiseid}/patient/${data?.patientid}/updateQualityRiskMetrics?quality_risk_metrics=${value}`
        
      );
      if (response.status === 200) {
          setSelectedRiskAdjustment(value);
          setToastMessage("Successfully updated");
          setToastSeverity("success");
          setOpenToast(true);
      } else {
        setToastMessage(
          response?.message || "Failed to update "
        );
        setToastSeverity("info");
        setOpenToast(true);
      }
    } catch (error) {
      console.log(error);
      setToastMessage("Failed to update ");
      setToastSeverity("error");
      setOpenToast(true);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAppointments = async () => {
    try {
      setIsLoading(true);
      const response = await api.get(
        `/v1/${practiseid}/pcard/${data?.patientid}/get_patient_history`
      );
      if (response.status === 200) {
        setAppointmentHistory(response.data || []);
      } else {
        setAppointmentHistory([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleToastClose = () => setOpenToast(false);

  const handleSaveContact = async (newPhone) => {
    try {
      setIsLoading(true);
      const response = await api.put(
        `/v1/${practiseid}/pcard/patient/${data?.patientid}/department/${userConfig?.config?.departmentid}/patientinfoupdate`,
        {
          phone: newPhone,
          dob: dob,
        }
      );
      if (response.status === 200) {
        setPhonenumber(newPhone);
        setToastMessage("Contact information updated successfully");
        setToastSeverity("success");
        setOpenToast(true);
      } else {
        setToastMessage(
          response?.message || "Failed to update contact information"
        );
        setToastSeverity("info");
        setOpenToast(true);
      }
    } catch (error) {
      console.log(error);
      setToastMessage("Failed to update contact information");
      setToastSeverity("error");
      setOpenToast(true);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchvisits = async () => {
    try {
      const response = await api.get(
        `/v1/${practiseid}/appointments/${data?.patientid}/visits`
      );
      if (response.status === 200) {
        setvisitsdata(response.data || []);
      } else {
        setvisitsdata([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
const syncinsurance= async()=>{
try {
  setIssyncing(true)
  await api.post(`/v1/${practiseid}/patient/${data.patientid}/department/1/sync`)
  await api.post(`/v1/${practiseid}/patient/${data.patientid}/department/1/insurance-sync`)
} catch (error) {
  console.log(error)
}finally{
  refereshpcard()
  setIssyncing(false)
}
}
  const fetchPayments = async () => {
    try {
      setIsLoading(true);
      const response = await api.get(
        `/v1/${practiseid}/pcard/${data?.patientid}/getPaymentDetails`
      );
      if (response.status === 200) {
        setpaymentsHistory(response.data || []);
      } else {
        setpaymentsHistory([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (data?.patientid && isPcard) fetchvisits();
  }, [data, isPcard]);

  useEffect(() => {
    if (data?.patientid && isPcard) {
      if (activeTab === "appointments") fetchAppointments();
      else fetchPayments();
    }
  }, [activeTab, data, isPcard]);
  const trigeerReview = async () => {
    try {
      setReviewTriggered(true);
      const response = await api.post(
        `/v1/${practiseid}/patient/${data?.patientid}/notification/google-review`
      );
      if (response.status === 200) {
        setToastSeverity("success");
        setToastMessage(response?.message || "Notification Sent Successfully");
        setOpenToast(true);
      } else {
        setToastSeverity("info");
        setToastMessage(response?.message || "something went wrong");
        setOpenToast(true);
      }
    } catch (error) {
      console.log(error);
      setToastSeverity("error");
      setToastMessage(error?.message || "something went wrong");
      setOpenToast(true);
    } finally {
      setReviewTriggered(false);
    }
  };
  if (!isPcard) return null;

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-white overflow-hidden">
      {/* Header */}
      <div className="sticky top-0 z-20 flex justify-between items-center bg-white px-6 py-3 shadow-sm">
        <h2 className="text-[#1d2951] text-lg font-bold">pCard</h2>
        <IconButton
          edge="end"
          aria-label="close"
          onClick={() => setPcard(false)}
          style={{ color: "#C7C7CB" }}
        >
          <CloseIcon />
        </IconButton>
      </div>

      {/* MAIN: Left rail + Right content */}
      <div className="flex min-h-0 flex-1 overflow-hidden">
        {/* LEFT RAIL (collapsible) */}
        <aside
          className={[
            "relative shrink-0 bg-[#FFF] shadow-md transition-all duration-300 ease-in-out no-scrollbar",
            collapsed ? "w-[100px]" : "w-[260px]",
          ].join(" ")}
        >
          {/* Toggle */}
          <button
            onClick={() => setCollapsed((s) => !s)}
            className="absolute -right-3 top-6 z-10 flex h-6 w-6 items-center justify-center rounded-full bg-[#E17954] shadow-xl focus:outline-none"
            aria-label="Toggle sidebar"
            title={collapsed ? "Expand" : "Collapse"}
          >
            {collapsed ? (
              <ChevronRightIcon className="h-3 w-3 text-white" />
            ) : (
              <ChevronLeftIcon className="h-3 w-3 text-white" />
            )}
          </button>

          {!collapsed && (
            <>
              <div
  className="relative group absolute top-14 left-6 cursor-pointer"
  onClick={() => setShowPopup(true)}
>
  {GoogleIcon}

  <span
    className="
      absolute left-0 top-full mt-2 z-50
    bg-[#1D2951] text-white text-[12px] px-2 py-1 rounded-md
      hidden group-hover:block 
      transition-opacity duration-200 
      opacity-0 group-hover:opacity-100
    "
  >
    Google Review
  </span>
</div>

              <div 
              onClick={()=> setChat(true)}
              className="relative group absolute top-16 left-6 cursor-pointer">
                {ChatIcon}
                <span
                  className="absolute left-0 top-full mt-2 
                  bg-[#1D2951] text-white text-[12px] px-2 py-1 rounded-md 
                   hidden group-hover:block transition-opacity duration-200 
                   opacity-0 group-hover:opacity-100 z-50"
                >
                  Chat
                </span>

              </div>
                   <div 
                   onClick={()=>{refereshpcard()}}
                   className="relative group absolute top-20 left-6 cursor-pointer">{syncbutton}  <span
                  className="absolute left-0 top-full mt-2 
                  bg-[#1D2951] text-white text-[12px] px-2 py-1 rounded-md 
                   hidden group-hover:block transition-opacity duration-200 
                   opacity-0 group-hover:opacity-100"
                >
        Sync
                </span></div>
            </>
          )}

          {/* Content */}
          <div className="flex h-full flex-col">
            {/* Top / Profile */}
            <div className={collapsed ? "px-3 pt-6" : "px-3 pt-10"}>
              <div className="mx-auto">
                {collapsed && (
                  <>
                    <div
  className="relative group cursor-pointer mb-2 flex justify-center"
  onClick={() => setShowPopup(true)}
>
  {GoogleIcon}

  <span
    className="
      absolute left-0 top-full mt-2 z-50
      bg-[#1D2951] text-whitetext-[12px] px-2 py-1 rounded-md
      hidden group-hover:block 
      transition-opacity duration-200 
      opacity-0 group-hover:opacity-100
    "
  >
    Google Review
  </span>
</div>

                    <div className="relative group mb-2 flex justify-center cursor-pointer">
                      {ChatIcon}
                      <span className="absolute left-full -ml-2 top-1/2 z-50 -translate-y-1/2 hidden group-hover:block bg-[#000D14] text-white text-[12px] px-2 py-1 rounded-md whitespace-nowrap transition-opacity duration-200 opacity-0 group-hover:opacity-100">
                        Chat
                      </span>
                      
                    </div>
                        <div      onClick={()=>{refereshpcard()}} className="relative group mb-2 flex justify-center cursor-pointer">{syncbutton}  <span
                  className="absolute left-0 top-full mt-2 z-50
                   bg-[#1D2951] text-white text-[12px] px-2 py-1 rounded-md 
                   hidden group-hover:block transition-opacity duration-200 
                   opacity-0 group-hover:opacity-100"
                >
                 Sync
                </span></div>
                  </>
                )}
                <div
                  className={[
                    "relative mx-auto  bg-white shadow-sm",
                    collapsed
                      ? "h-[52px] w-[52px] rounded-md p-1"
                      : "h-[70px] w-[70px] rounded-lg p-2",
                  ].join(" ")}
                >
                  {/* Green ring or custom border */}
                  <div
                    className={[
                      "absolute inset-0 rounded-lg",
                      collapsed ? "rounded-md" : "rounded-lg",
                    ].join(" ")}
                    style={{
                      border: `3.5px solid #${data?.deductiblemet}`,
                    }}
                  />

                  {/* Profile image */}
                  <div
                    className={[
                      "relative h-full w-full overflow-hidden",
                      collapsed ? "rounded-md" : "rounded-lg",
                    ].join(" ")}
                  >
                    <img
                      src={`/cloud-assets/chim/public/assets/images/profilepictures/${data?.patientid}.png`}
                      alt="profile"
                      onError={(e) =>
                        (e.target.src =
                          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
                      }
                      className="block h-full w-full object-cover"
                    />
                  </div>
                </div>
              </div>

              {collapsed ?   <button
                  onClick={() => setOpenContactModal(true)}
                  className=" flex w-full items-center justify-center rounded-xl border mt-4 bg-white border-[#50869A4D] px-2  py-2 text-sm text-[#334155]"
                >
                  {dobb}
                </button> : (
                <>
                  <div className="mt-3 text-center">
                    <div className="text-[16px] font-medium font-inter text-[#202020]">
                      {`${data?.firstname || ""} ${
                        data?.lastname || ""
                      }`.trim() || "-"}
                    </div>
                    <div className="mt-1 text-[#7E7E7E] font-inter font-medium text-xs">
                      #{data?.patientid || "-"}
                    </div>
                  </div>

                  {/* Facts */}
                  <div className="mt-8 space-y-5 text-left">
                    {/* DOB */}
                    <div className="px-1">
                      <div className="text-xs text-[#7E7E7E] font-inter font-medium">
                        DOB:
                      </div>
                      <div className="mt-1 text-sm text-[#202020] font-inter font-medium">
                    {dayjs(dob || data?.dob).format("MM/DD/YYYY")}
                      </div>
                    </div>

                    {/* Healthcare */}
                    <div className="px-1">
                      <div className="text-xs text-[#7E7E7E] font-inter font-medium">
                        Healthcare
                      </div>
                      <div className="mt-1 text-sm text-[#202020]  flex items-center gap-2 font-inter font-medium">
                        {data?.insurancename || "-"}  <div className=" cursor-pointer" onClick={()=>{syncinsurance()}}>{syncbuttonsmall}</div>  
                      </div>
                    </div>

                    {/* Last visit */}
                    <div className="px-1">
                      <div className="text-xs text-[#7E7E7E] font-inter font-medium">
                        Last visit
                      </div>
                      <div className="mt-1 text-sm text-[#202020] font-inter font-medium">
                        {visitsdata?.last_visit?.startdate
                          ? dayjs(visitsdata.last_visit.startdate).format(
                              "MM-DD-YYYY"
                            )
                          : ""}
                      </div>
                    </div>

                    {/* Next visit */}
                    <div className="px-1">
                      <div className="text-xs text-[#7E7E7E] font-inter font-medium">
                        Next visit
                      </div>
                      <div className="mt-1 text-sm text-[#202020] font-inter font-medium">
                        {visitsdata?.next_visit?.startdate
                          ? dayjs(visitsdata.next_visit.startdate).format(
                              "MM-DD-YYYY"
                            )
                          : "-"}
                      </div>
                    </div>

                    
<div className="px-1">
  <div className="text-xs text-[#7E7E7E] font-inter font-medium">
    Risk Adjustments/Quality Measures
  </div>

  <select
    value={selectedRiskAdjustment}
    onChange={handleRiskAdjustmentChange}
    className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-[#202020] font-inter font-medium focus:outline-none focus:ring-2 focus:ring-blue-500"
  >
    <option value="">Select</option>
    <option value="ACO">ACO</option>
    <option value="WellMed">WellMed</option>
    <option value="United Healthcare">United Healthcare</option>
  </select>
</div>

                     <div className=" px-5 pb-6">
            <button
  onClick={() => setOpenContactModal(true)}
  className="flex w-full items-center justify-center gap-2 rounded-xl border bg-white border-[#50869A4D] font-inter font-medium px-3 py-2 text-xs text-[#6A7282] whitespace-nowrap"
>
  <span className="flex-shrink-0">{dobb}</span>
  <span>Update Info</span>
</button>

              </div>
                  </div>
                </>
              )}
            </div>

            {/* Bottom button (hidden when collapsed) */}
            {/* {!collapsed ? (
              <div className="mt-auto px-5 pb-6">
                <button
                  onClick={() => setOpenContactModal(true)}
                  className="mx-auto flex w-full items-center justify-center gap-2 rounded-xl border bg-white border-[#50869A4D] font-inter font-medium px-3 py-2 text-xs text-[#6A7282]"
                >
                  {dobb}
                  <span>Update Info</span>
                </button>
              </div>
            ) : (
              <div className="mt-auto px-4 pb-6 text-left">
                <button
                  onClick={() => setOpenContactModal(true)}
                  className=" flex w-full items-center justify-center rounded-xl border bg-white border-[#50869A4D] px-2  py-2 text-sm text-[#334155]"
                >
                  {dobb}
                </button>
              </div>
            )} */}
          </div>
        </aside>

        {/* RIGHT CONTENT */}
        <div className="flex-1 min-w-0 overflow-y-auto bg-[#EFF6FF4D]">
          <div className="px-6 pt-6 pb-10">
            <div className="w-full">
              <PatientTabs
                activeTab={activeTab}
                data={data}
                setActiveTab={setActiveTab}
                isLoading={isLoading}
                paymentshistory={paymentshistory}
                appointmenthistory={appointmenthistory}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Modals & Toasts */}
      <UpdateContactModal
        open={openContactModal}
        onClose={() => setOpenContactModal(false)}
        phone={data.phone}
        onSave={handleSaveContact}
      />
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={handleToastClose}
      />

      <ConfirmReviewModal
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        onConfirm={() => {
          trigeerReview();
          setShowPopup(false);
        }}
      />
         {chat?<ChatWrapper setChat={setChat} patientdata={data} flow={'comment'} top={'0px'} />:<></>}
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        }}
        open={isLoading || reviewtriggered||issyncing}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
